import { gql } from "lib/apolloClient";

export const updateAdminPermissionDetailsMutation = gql`
  mutation updateStaffPermissionProgramAdminValue(
    $updatedValues: [UpdateStaffPermissionProgramAdminValueInput!]!
  ) {
    platform {
      updateStaffPermissionProgramAdminValue(input: $updatedValues) {
        id
      }
      __typename
    }
  }
`;

export const updateStaffModuleAccessMutation = gql`
  mutation updateStaffPermissionModules(
    $updatedValues: [UpdateStaffPermissionModulesInput!]!
  ) {
    platform {
      updateStaffPermissionModules(input: $updatedValues) {
        id
      }
      __typename
    }
  }
`;
